<template>
  <v-dialog
      class=""
      v-model="innerOpen"
      persistent
      width="800"
  >
    <v-card class="">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Print eTA</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <div class="mt-4" id="printable_content_eta" ref="capture">
          <eta-print-content />
        </div>
      </v-card-text>

      <v-divider style="margin-top:31px;"/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            @click="save"
            class="white--text"
            color="blue darken-3"
        >Print
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { SET_PRINT_CONTENT } from "@/store/mutation-type";
import EtaPrintContent from "/src/components/visa/EtaPrintContent.vue";

export default {
  name: "PrintEtaDialog",
  components: {EtaPrintContent},
  props: ['value'],
  data() {
    return {
      innerOpen: false,
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    }
  },
  methods: {
    async save(){
      const content = document.getElementById('printable_content_eta').innerHTML;
      this.$store.commit(SET_PRINT_CONTENT, content);
      setTimeout(() => {
        window.print()
      }, 100);
    },
    cancel() {
      this.innerOpen = false;
      this.$emit('input', false)
    },
  },
}
</script>

<style>

</style>
